import { useQuery, QueryHookOptions } from '@apollo/client';

import { GET_MULTIPLE_SHOPIFY_STATS_QUERY } from '@affiliates/queries';
import { GetMultipleShopifyStats, GetMultipleShopifyStatsVariables } from '@affiliates/queries/types/GetMultipleShopifyStats';

type TOptions = QueryHookOptions<GetMultipleShopifyStats, GetMultipleShopifyStatsVariables>;

export const useGetMultipleShopifyStatsQuery = (options: TOptions = {}) => useQuery<GetMultipleShopifyStats, GetMultipleShopifyStatsVariables>(GET_MULTIPLE_SHOPIFY_STATS_QUERY, options);
